<table class="table table-bordered table-hover">
  <thead class="table-dark">
    <tr>
      <th>CONSULT NOTE ID</th>
      <th>RECEIVED ON</th>
      @if (!myWorkQueue) {
        <th>STATUS</th>
      }
      <th>CLIENT</th>
      <th>FAX NUMBER</th>
      <th>OFFICE</th>
      <th>CE PATIENT</th>
      <th>OFFICE ESTIMATED VALUE</th>
      @if (!myWorkQueue) {
        <th>ASSIGNED TO</th>
      }
      <th>NEAREST EXPIRATION DATE</th>
      <th>PRIORITY</th>
    </tr>
  </thead>
  <tbody>
    @for (consultNoteQueueResult of consultNoteQueueResults; track consultNoteQueueResult) {
      <tr
        [ngClass]="{ 'selected' : isSelected(consultNoteQueueResult) }">
        <td class="id-column">
          @if (canAssignUser) {
            <input
              type="checkbox"
              [checked]="isSelected(consultNoteQueueResult)"
              (click)="handleConsultNoteSelection(consultNoteQueueResult)"
              class="me-1"
              />
          }
          <a routerLink="/capture-admin/consult-notes/{{consultNoteQueueResult.id}}">
            <span class="text-nowrap">{{ consultNoteQueueResult.id }}</span>
          </a>
          <div>
            <app-user-presence category="consultNote" [targetId]="consultNoteQueueResult.id" />
          </div>
        </td>
        <td class="text-end">
          {{ consultNoteQueueResult.createdAt | date: 'MM/dd/yyyy' }}
        </td>
        @if (!myWorkQueue) {
          <td>
            {{ consultNoteQueueResult.status | patientAttachmentStatus }}
          </td>
        }
        <td>
          {{ consultNoteQueueResult.client.name }}
        </td>
        <td>
          <app-phone-number [allowCopyToClipboard]="true" [number]="consultNoteQueueResult.outboundFaxNumber" />
        </td>
        <td>
          <app-consult-note-office [providerOffice]="consultNoteQueueResult.associatedProviderOffice" />
        </td>
        <td>
          <app-patient-name [patient]="consultNoteQueueResult.patient" [showAlternateNames]=false />
        </td>
        <td class="estimated-value-column">
          <app-consult-note-estimated-values [patientAttachment]="consultNoteQueueResult" />
        </td>
        @if (!myWorkQueue) {
          <td>
            @if (consultNoteQueueResult.assignedTo) {
              {{ consultNoteQueueResult.assignedTo.fullName }}
            }
          </td>
        }
        <td>
          {{ consultNoteQueueResult.nextHighValueExpirationDate | date: 'MM/dd/yyyy' }}
        </td>
        <td>
          {{ consultNoteQueueResult.priority }}
        </td>
      </tr>
    }
  </tbody>
</table>
